export default "__VITE_ASSET__DKKtZ6bN__"